package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.model.Me
import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class GetMeUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): Me? = accountRepository.getMe()
}
